// Runtime enforcement of Microsoft Clarity exclusions for internal/staff users.
// The index.html snippet only evaluates at initial page load, so a super_admin who
// lands anonymously on /login (Clarity starts) and then signs in keeps getting
// recorded because the SPA never reloads. This stops that session as soon as we
// know the authenticated user is excluded.

const EXCLUDED_TENANTS = [
  "ten_6404ab618459", "ten_101bb8d08aa6", "ten_hospital_demo",
  "ten_demo_starter", "ten_demo_growth", "ten_demo_professional", "ten_demo_business",
];

export function isClarityExcludedUser(u) {
  if (!u) return false;
  const role = (u.role || "").toLowerCase();
  const email = (u.email || "").toLowerCase();
  const tenant = u.tenant_id || "";
  if (role === "super_admin" || role === "developer" || u.is_demo || u.is_internal || email.indexOf("@recoveros.in") > -1) return true;
  if (tenant && EXCLUDED_TENANTS.indexOf(tenant) > -1) return true;
  return false;
}

let stopped = false;

export function enforceClarityExclusion(u) {
  if (stopped || typeof window === "undefined") return;
  if (!isClarityExcludedUser(u)) return;

  const role = (u.role || "").toLowerCase();
  const tenant = u.tenant_id || "";

  const tryStop = (attempt = 0) => {
    if (typeof window === "undefined") return;
    if (window.clarity) {
      try {
        // Tag the partial session so it's filterable in the Clarity dashboard, then halt.
        if (role) window.clarity("set", "role", role);
        if (tenant) window.clarity("set", "tenant", String(tenant));
        window.clarity("consent", false);
        window.clarity("stop");
      } catch (e) { /* noop */ }
      stopped = true;
    } else if (attempt < 20) {
      // Clarity loads async on prod hosts; retry briefly. On preview it never loads (no-op).
      setTimeout(() => tryStop(attempt + 1), 250);
    }
  };
  tryStop();
}
